import {Config} from './Config/Config';
import StateList from './StateList';

export default class Requests {
    constructor(){}
    
    static getMVTQueryString(_body, _tableSuffix, _column){
      return `${Config.api.hosts.nodeHostAddress}/mvt/${_body}_${_tableSuffix}/{z}/{x}/{y}?geom_column=geom&columns=${_column}`
    }

    
    static getDistrictsFromLatLng(_lng,_lat,_body, _age){
        //Example: http://localhost:3001/intersect_point/public.%22stateAssembly_new%22/-76.1175%2C42.9677%2C4326?geom_column=geom&columns=geoid&distance=0
        return `${Config.api.hosts.nodeHostAddress}/intersect_point/"${_body}_${_age}"/${_lng},${_lat},4326?geom_column=geom&columns=geoid&distance=0`
      }

      static getDistrictBoundingBox(_body, _tableSuffix,_geoid){
        //Example: http://localhost:3001/bbox/%22congress_new%22?geom_column=geom&srid=4326&filter=geoid%3D'3625'
        return `${Config.api.hosts.nodeHostAddress}/bbox/"${_body}_${_tableSuffix}"?geom_column=geom&srid=4326&filter=geoid='${_geoid}'`
      }

        static getProPublicaData(state,district){
      //Example: https://api.propublica.org/congress/members/house/OR/4/current.json (API Key in Header!)
      const _state = StateList.filter((s)=>s.value === state);
      const abbrev = _state[0].abbrev;
      
      if(district){
        return `${Config.api.hosts.propublica}/congress/v1/members/house/${abbrev}/${district}/current.json`
      }
        return `${Config.api.hosts.propublica}/congress/members/senate/${abbrev}/current.json`
    }

    static getProPublicaHeaders(){
      return {
        'X-API-Key': Config.api.keys.ProPublicaAPIKey
      }
    }

    static getCentroids(_stateFips, _body, _age, _field = 'geoid'){
      //Example: http://localhost:3001/labels/%22stateSenate_old%22?geom_column=geom&filter=statefips%3D'36'&srid=4326&force_on_surface=true

      //https://dev-api.districting2021.com/labels/congress_demographics?labelfield=distlabel&geom_column=geom&srid=4326&force_on_surface=true
      if(_stateFips){
        return `${Config.api.hosts.nodeHostAddress}/labels/"${_body}_${_age}".json?geom_column=geom&filter=statefips%3D'${_stateFips}'&srid=4326&labelfield=${_field}&force_on_surface=true`
      }
      return `${Config.api.hosts.nodeHostAddress}/labels/"${_body}_${_age}".json?geom_column=geom&srid=4326&labelfield=${_field}&force_on_surface=true`

    }

  }